// client/extensions/TextStyle.ts
import TiptapTextStyle from "@tiptap/extension-text-style";
var TextStyle = {
  extensions: [TiptapTextStyle]
};
export {
  TextStyle
};
